import { render, staticRenderFns } from "./ValidationPopupWithTitle.vue?vue&type=template&id=266cf27e&"
import script from "./ValidationPopupWithTitle.vue?vue&type=script&lang=js&"
export * from "./ValidationPopupWithTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports